import {
  FETCH_QUOTES_REQUEST,
  FETCH_QUOTES_SUCCESS,
  FETCH_QUOTES_FAILURE,
  FETCH_QUOTE_REQUEST,
  FETCH_QUOTE_SUCCESS,
  FETCH_QUOTE_FAILURE,
  UPDATE_QUOTES_REQUEST,
  UPDATE_QUOTES_FAILURE,
  UPDATE_QUOTES_SUCCESS,
  DELETE_QUOTES_REQUEST,
  DELETE_QUOTES_FAILURE,
  DELETE_QUOTES_SUCCESS,
  CREATE_QUOTE_REQUEST,
  CREATE_QUOTE_SUCCESS,
  CREATE_QUOTE_FAILURE,
  QUOTE_TO_PDF_REQUEST,
  QUOTE_TO_PDF_SUCCESS,
  QUOTE_TO_PDF_FAILURE,
  CLEAR_QUOTE_ERRORS,
  CLEAR_QUOTE_SUCCESS,
} from './actionTypes';

const initialState = {
  quotes: [],
  quote: null,
  loadingQuote: false,
  lastCreatedQuote: null,
  errorQuote: null,
  quoteAdded: null,
  loadingCreateQuote: false,
  errorCreateQuote: null,
  loadingQuoteToPdf: false,
  errorQuoteToPdf: null,
};

const Quotes = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_QUOTES_REQUEST:
      return {
        ...state,
        loadingQuote: true,
        errorQuote: null,
        quoteAdded: false
      };
    case FETCH_QUOTES_SUCCESS:
      return {
        ...state,
        loadingQuote: false,
        quotes: action.payload,
      };
    case FETCH_QUOTES_FAILURE:
      return {
        ...state,
        loadingQuote: false,
        errorQuote: action.payload,
      };
    case FETCH_QUOTE_REQUEST:
      return {
        ...state,
        loadingQuote: true,
        errorQuote: null,
        quoteAdded: false
      };
    case FETCH_QUOTE_SUCCESS:
      return {
        ...state,
        loadingQuote: false,
        quote: action.payload,
      };
    case FETCH_QUOTE_FAILURE:
      return {
        ...state,
        loadingQuote: false,
        errorQuote: action.payload,
      };
    case UPDATE_QUOTES_REQUEST:
      return {
        ...state,
        loadingQuote: true,
        errorQuote: null,
        quoteAdded: false
      };
    case UPDATE_QUOTES_SUCCESS:
      return {
        ...state,
        loadingQuote: false,
        quote: null,
        quoteAdded: true
      };
    case UPDATE_QUOTES_FAILURE:
      return {
        ...state,
        loadingQuote: false,
        errorQuote: action.payload,
      };
    case DELETE_QUOTES_REQUEST:
      return {
        ...state,
        loadingQuote: true,
        errorQuote: null,
        quoteAdded: false
      };
    case DELETE_QUOTES_SUCCESS:
      return {
        ...state,
        quoteAdded: true,
        loadingQuote: false,
        quotes: state.quotes.filter(quote => quote.id !== action.payload),
      };
    case DELETE_QUOTES_FAILURE:
      return {
        ...state,
        loadingQuote: false,
        errorQuote: action.payload,
      };
    case CREATE_QUOTE_REQUEST:
      return {
        ...state,
        loadingCreateQuote: true,
        errorCreateQuote: null,
      };
    case CREATE_QUOTE_SUCCESS:
      return {
        ...state,
        loadingCreateQuote: false,
        errorCreateQuote: null,
      };
    case CREATE_QUOTE_FAILURE:
      return {
        ...state,
        loadingCreateQuote: false,
        errorCreateQuote: action.payload,
      };
    case QUOTE_TO_PDF_REQUEST:
      return {
        ...state,
        loadingQuoteToPdf: true,
        errorQuoteToPdf: null,
      };
    case QUOTE_TO_PDF_SUCCESS:
      return {
        ...state,
        lastCreatedQuote: action.payload,
        loadingQuoteToPdf: false,
        errorQuoteToPdf: null,
      };
    case QUOTE_TO_PDF_FAILURE:
      return {
        ...state,
        lastCreatedQuote: null,
        loadingQuoteToPdf: false,
        errorQuoteToPdf: action.payload,
      }; 
    case CLEAR_QUOTE_ERRORS:
      return {
        ...state,
        errorQuote: null,
        errorCreateQuote: null,
        errorQuoteToPdf: null,
      };
    case CLEAR_QUOTE_SUCCESS:
      return {
        ...state,
        quoteAdded: null,
        lastCreatedQuote: null,
      };
      
    default:
      return state;
  }
};

export default Quotes;